import {CUSTOMER_TYPE_KEY_TYPE} from "@/shared/model";
import * as z from "zod";

const schema = z.object({
	id: z.string(),
	customerType: CUSTOMER_TYPE_KEY_TYPE,
	storeName: z.string().nullable(), // 상호면
	representativeName: z.string().nullable(), // 대표자명
	telephone: z.string().nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const CustomerResModel = {schema, model};
export type ICustomerResModel = z.infer<typeof CustomerResModel.model>;
export const DEFAULT_CUSTOMER_RES: ICustomerResModel = {
	id: "",
	customerType: "UNKNOWN",
	storeName: "",
	representativeName: "",
	telephone: ""
};
